module.exports = __webpack_public_path__ + "img/5.c5a962c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/academic/5.png
// module id = 590
// module chunks = 5